import { cn } from "common/helpers/utils";

import type { HTMLAttributes } from "react";

export default function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md shrink-0 bg-black-300",
        className,
      )}
      {...props}
    />
  );
}
